import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

type SeparatorProps = {
  className?: string
}

export const Separator = ({ className }: SeparatorProps) => {
  const classes = useStyles()

  return <hr className={clsx(classes.separator, className)} />
}

const useStyles = makeStyles({
  separator: {
    border: '0.5px solid #9E9E9E',
    margin: 0,
  },
})
